// Diego, 14-oct: «si alguien se regresa a modificar la propuesta (un panel más, un descuento…), que se note de inmediato en el
// PDF». Una sola regla para la pestaña PDF y su insignia: el último PDF generado es de ANTES del último cálculo.
import type { DetalleCotizacion } from '@cotizador/compartido';

/** El último PDF (la versión con PDF de número más alto) se generó antes del último cálculo de la cotización. Una ampliación de
 *  baterías no tiene `resultado` (ni su hora de cálculo): ahí cuenta un cambio a su captura (/piezas) o al cuestionario
 *  guardado DESPUÉS del último PDF (en el historial que trae el detalle), y que el precio de HOY no sea el que cobra ese PDF
 *  (verificación de código del 27-oct: Diego cambia la comisión o la tabla, o se reasigna el vendedor, y el precio cambia sin
 *  tocar /piezas): el contado con IVA de la última versión (contado_recomendada = loQueCobraElPdf) contra calculo_piezas. */
export function pdfDesactualizado(detalle: Pick<DetalleCotizacion, 'versiones' | 'cotizacion'> & Partial<Pick<DetalleCotizacion, 'eventos'>>): boolean {
  const ultima = detalle.versiones.filter((v) => v.pdf).sort((a, b) => b.numero - a.numero)[0];
  if (detalle.cotizacion.borrador.cuestionario?.tipo === 'ampliacion_baterias') {
    if (!ultima) return false;
    const hoy = detalle.cotizacion.borrador.calculo_piezas?.contado_con_iva ?? null;
    const cobra = ultima.contado_recomendada ?? null;
    if (cobra !== null && hoy !== cobra) return true;
    return (detalle.eventos ?? []).some((e) => e.tipo === 'editada' && e.en > ultima.creada_en && (e.ediciones ?? []).some((x) => x.ruta.startsWith('/piezas') || x.ruta.startsWith('/cuestionario')));
  }
  const calc = detalle.cotizacion.borrador.resultado?.calculado_en;
  if (!calc) return false;
  return !!ultima && ultima.creada_en < calc;
}
